import * as S from './DPSoldOut.styles';

import TimerIcon from '../../../../../stories/assets/hotels/details/timerIcon.svg';
import TriggerAnchorText from '../../../../../shared/components/TriggerActionText';

const noop = () => {};

const DPSoldOut: React.FC<{
  tryAlternateDatesClick: Function;
  showSimilarHotelsClick: Function;
  onSeeOtherHotelsClick: Function;
  showSimilarHotelsText: boolean;
  srpUrl: string;
  cityName: string;
}> = ({
  tryAlternateDatesClick = noop,
  showSimilarHotelsClick = noop,
  onSeeOtherHotelsClick = noop,
  showSimilarHotelsText,
  srpUrl,
  cityName,
}) => (
  <S.SoldOutWrapperDiv>
    <S.SoldOutInnerDiv>
      <S.IconWrapperSpan>
        <TimerIcon />
      </S.IconWrapperSpan>

      <S.SoldOutTextWrappDiv>
        <S.FirstTxtPara>Soldout on Goibibo!</S.FirstTxtPara>
        <span>Your dates are very popular</span>
        {/* <S.AlternateDateLink>Try Alternate Dates</S.AlternateDateLink> */}
      </S.SoldOutTextWrappDiv>

      <S.ActionTextsContainer>
        <S.TryAlternateDatesButton onClick={tryAlternateDatesClick}>
          Try Alternate Dates
        </S.TryAlternateDatesButton>

        {showSimilarHotelsText && (
          <TriggerAnchorText
            onClick={() => {
              showSimilarHotelsClick();
            }}
          >
            <S.SoldOutTriggerText uppercase>Show Similar Hotels</S.SoldOutTriggerText>
          </TriggerAnchorText>
        )}

        {srpUrl && (
          <TriggerAnchorText onClick={() => onSeeOtherHotelsClick()} href={srpUrl}>
            <S.SoldOutTriggerText uppercase>
              See Other Hotels {cityName ? `For ${cityName}` : ''}
            </S.SoldOutTriggerText>
          </TriggerAnchorText>
        )}
      </S.ActionTextsContainer>
    </S.SoldOutInnerDiv>
  </S.SoldOutWrapperDiv>
);

export default DPSoldOut;
